export const normalizeAssetPath = (assetPath = "") => {
  if (!assetPath) {
    return "";
  }

  if (/^https?:\/\//.test(assetPath)) {
    return assetPath;
  }

  return `${process.env.PUBLIC_URL}/${assetPath.replace(/^\/+/, "")}`;
};

export const INITIAL_REGISTER_FORM = {
  nombre: "",
  usuario: "",
  contrasena: "",
  confirmarContrasena: "",
  email: "",
  telefono: "",
};

export const isSecurePassword = (value) =>
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/.test(String(value || ""));

export const validatePasswordWithFeedback = (value) => {
  const errors = [];
  const v = String(value || "");
  if (v.length < 8) errors.push("La contraseña debe tener al menos 8 caracteres.");
  if (!/[a-z]/.test(v)) errors.push("La contraseña debe contener al menos una letra minúscula.");
  if (!/[A-Z]/.test(v)) errors.push("La contraseña debe contener al menos una letra mayúscula.");
  if (!/[0-9]/.test(v)) errors.push("La contraseña debe contener al menos un número.");
  if (!/[^A-Za-z\d]/.test(v)) errors.push("La contraseña debe contener al menos un carácter especial.");
  return errors;
};